import { render } from "./SetCompany.vue?vue&type=template&id=60128172&scoped=true"
import script from "./SetCompany.vue?vue&type=script&lang=js"
export * from "./SetCompany.vue?vue&type=script&lang=js"

import "./SetCompany.vue?vue&type=style&index=0&id=60128172&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\galita-api\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60128172"]])

export default __exports__